var coucouSlider, moveNext, movePrev, moveTo;

coucouSlider = function () {
  return $(".coucou-slider").each(function () {
    var $current, $next, $this, hash;
    $this = $(this);
    if ($this.children("li").length > 1) {
      $(".move-next").on("click", function (e) {
        return moveNext();
      });
      $(".move-prev").on("click", function (e) {
        return movePrev();
      });
      $(".media img").on("click", function (e) {
        e.preventDefault();
        return moveNext();
      });
      $(".move-to-slide").on("click touchstart", function (e) {
        e.preventDefault();
        return moveTo($(this).data("slide-id"));
      });
      hash = window.location.hash.replace(/#/, "");
      $current = $this.children("li.active");
      if (
        $("*[data-slide-id='" + hash + "']").length &&
        hash !== $current.data("slide-id")
      ) {
        $next = $("*[data-slide-id='" + hash + "']");
        $(".coucou-slider li").not($next).removeClass("active");
        return $next.addClass("active");
      }
    }
  });
};

moveNext = function () {
  var $current, $next, $slides;
  $slides = $(".coucou-slider");
  $current = $slides.children("li.active");
  if ($current.is(":last-child")) {
    $next = $slides.children("li:first-child");
  } else {
    $next = $current.next();
  }
  return $next.imagesLoaded(function () {
    $current.removeClass("active");
    window.location.hash = $next.data("slide-id");
    return $next.addClass("active");
  });
};

movePrev = function () {
  var $current, $next, $slides;
  $slides = $(".coucou-slider");
  $current = $slides.children("li.active");
  if ($current.is(":first-child")) {
    $next = $slides.children("li:last-child");
  } else {
    $next = $current.prev();
  }
  return $next.imagesLoaded(function () {
    $current.removeClass("active");
    window.location.hash = $next.data("slide-id");
    return $next.addClass("active");
  });
};

moveTo = function (slide_id) {
  var $current, $next;
  $next = $("*[data-slide-id='" + slide_id + "']");
  $current = $(".coucou-slider").children("li.active");
  if (slide_id !== $current.data("slide-id")) {
    $current.removeClass("active");
    window.location.hash = $next.data("slide-id");
    return $next.addClass("active");
  }
};

$(document).on("page:load", coucouSlider);

$(function () {
  return coucouSlider();
});

// ---
// generated by coffee-script 1.9.2
